
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/9e9d8cdbd7f8ff4152b95a4cc643d639.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <h2 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
            Premium Rolling Services
            <br />
            <span className="text-emerald-400">for Exclusive Events</span>
          </h2>
          <p className="text-xl lg:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed text-gray-200">
            Elevate your private gatherings with our discreet, professional staff and luxury equipment. 
            Tailored experiences for the most discerning clientele.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={scrollToContact}
              className="bg-emerald-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-emerald-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Your Event
            </button>
            <button 
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              View Services
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
